import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import serverUrl from '../constants/serverUrl';


export default class ProductList extends Component {

  renderProduct = (p, ind) => {
    return (
      <div key={ind} className="col-md-4  px-4 px-sm-2" style={{padding: '10px 15px' }}>
        <div className="row">
          <NavLink to={"/product/" + p.id} style={{margin: '0 auto'}}>
            <div className="contain" style={{height: '220px'}}>
              {p.primaryImageLink ? (
                <img className="brighten" src={serverUrl + p.primaryImageLink} alt={p.name + '-image'} />
              ) : (
                <span>No Image</span>
              )}
            </div>
          </NavLink>
        </div>
        <div className="row" style={{paddingTop: '15px'}}>
          <div className="col-md-12">
            <NavLink style={{textDecoration: 'none'}} to={"/product/" + p.id}>
              <span className="product-name grey-text">
                { p.name }
              </span>
            </NavLink>
            <div className="block-with-text grey-text" style={{maxHeight: 'unset', lineHeight:'16px', fontSize: '12px', fontWeight: 300}}>
              { p.subheading ? p.subheading : p.description }
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <NavLink to={"/product/" + p.id} style={{margin: '0 auto', color: 'turquoise', fontSize: '10px'}}>
              find out more
            </NavLink>
          </div>
          <div className="col-md-6">
            <a className='sds-btn' href={'/getsds/' + p.id }>Download SDS</a>
          </div>
        </div>
      </div>
    )
  }

  render() {
    console.log("list ", this.props.products)
    return (
      <div className="row" style={{paddingLeft: '10px', paddingRight: '20px'}}>
        { this.props.products.map(this.renderProduct) }
      </div>
    );
  }

}



// WEBPACK FOOTER //
// src/components/ProductsList.js